'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM


var ConditionalActionButton = function (_Component) {
  _inherits(ConditionalActionButton, _Component);

  function ConditionalActionButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConditionalActionButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConditionalActionButton.__proto__ || Object.getPrototypeOf(ConditionalActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      _this.props.conditional ? _this.props.onSuccess() : _this.props.onFailure();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConditionalActionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          conditional = _props.conditional,
          onSuccess = _props.onSuccess,
          onFailure = _props.onFailure,
          otherProps = _objectWithoutProperties(_props, ['className', 'children', 'conditional', 'onSuccess', 'onFailure']);

      return _react2.default.createElement(
        'button',
        _extends({ className: className, onClick: this.onClick }, otherProps),
        children
      );
    }
  }]);

  return ConditionalActionButton;
}(_react.Component);

ConditionalActionButton.propTypes = {
  className: _propTypes2.default.string,
  conditional: _propTypes2.default.bool.isRequired,
  onSuccess: _propTypes2.default.func.isRequired,
  onFailure: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired
};

exports.default = ConditionalActionButton;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/ConditionalActionButton.js
// module id = 586
// module chunks = 0